import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, restaurantName, restaurantType }) => {
  const defaultTitle = "CheF SKN | Food & Retail Delivery St. Kitts & Nevis";
  const defaultDescription = "Order food and retail from the best local restaurants and stores in St. Kitts and Nevis. Fast, reliable delivery straight to your doorstep via CheF SKN.";
  const defaultKeywords = "food delivery st kitts, retail delivery st kitts, order food nevis, order retail nevis, basseterre restaurants, frigate bay food delivery, chef skn, st kitts delivery, nevis food delivery, nevis retail delivery, caribbean delivery, supermarket delivery, pharmacy delivery";

  const pageTitle = title || defaultTitle;
  const pageDescription = description || defaultDescription;
  const pageKeywords = keywords || defaultKeywords;

  // Dynamic keywords based on content
  let dynamicKeywords = pageKeywords;
  if (restaurantName) {
    dynamicKeywords += `, ${restaurantName} st kitts, ${restaurantName} nevis, ${restaurantName} delivery`;
  }
  if (restaurantType) {
    dynamicKeywords += `, ${restaurantType} st kitts, ${restaurantType} nevis, ${restaurantType} delivery`;
  }

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={dynamicKeywords} />
      
      {/* Geographic tags for local SEO */}
      <meta name="geo.region" content="KN" />
      <meta name="geo.placename" content="Basseterre, Frigate Bay, Charlestown" />
      <meta name="geo.position" content="17.3578;-62.7719" />
      <meta name="ICBM" content="17.3578, -62.7719" />
      
      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      
      {/* Additional local SEO */}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
};

export default SEO;
